import { create, StoreApi, UseBoundStore } from 'zustand'

interface ServiceWorkerStoreState {
  isSupported: boolean
  isCheckingIfSupported: boolean
}

interface ServiceWorkerStoreActions {
  setIsSupported: (_isSupported: boolean) => void
  setIsCheckingIfSupported: (_isCheckingIfSupported: boolean) => void
  reset: () => void
}

type ServiceWorkerStore = ServiceWorkerStoreState & ServiceWorkerStoreActions

const initialState: ServiceWorkerStoreState = {
  isSupported: false,
  isCheckingIfSupported: true,
}

const useServiceWorkerStore: UseBoundStore<StoreApi<ServiceWorkerStore>> = create((set) => ({
  ...initialState,

  setIsSupported: (newIsSupported: boolean) => {
    set((state) => ({
      ...state,
      isSupported: newIsSupported,
    }))
  },

  setIsCheckingIfSupported: (newIsCheckingIfSupported: boolean) => {
    set((state) => ({
      ...state,
      isCheckingIfSupported: newIsCheckingIfSupported,
    }))
  },

  reset: () => {
    set(initialState)
  },
}))

export { useServiceWorkerStore }
